import React from "react"
import {
  AppLoginHeader,
  AppLoginContainer,
  LoginButton,
  LearnMoreButton,
  InstallButton
} from "./Login.styles"
import googleChatLogo from "../../assets/image/googlechat 1.png"
import { Typography } from "@mui/material"
import { GoogleLogin } from "react-google-login"
import { authService } from "src/services/auth.service"
import { useHistory } from "react-router-dom"
import { PATH } from "../../utils/constants/path.constants"
import { tokenService } from "../../services/token.service"
import { toastHelpers } from "../../utils/helpers/toast.helpers"
import { messages } from "../../utils/constants/messages"
import { SeverityEnum } from "../../utils/enums/toast.enum"
import { useAppDispatch } from "../../hooks/redux"
import { loading, unLoading } from "src/reducer/auth.reducer"
import { loginSuccess } from "src/reducer/app.reducer"
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
const GoogleLoginItem = () => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const onSuccess = res => {
    dispatch(loading())
    const state = "google_hangouts"
    authService.login(res.tokenId, state).then(result => {
      if (result.data.ok) {
        const authenticateRes = result.data.data
        afterSuccess(authenticateRes)
      } else {
        handleError()
      }
    })
  }
  const onSuccessInstall = res => {
    dispatch(loading())
    const state = "google_hangouts"
    authService.install(res.tokenId, state).then(result => {
      if (result.data.ok) {
        const authenticateRes = result.data.data
        afterSuccess(authenticateRes)
      } else {
        handleError()
      }
    })
  }
  const afterSuccess = authenticateRes => {
    dispatch(unLoading())
    tokenService.updateLocalAccessToken(authenticateRes.id_token)
    tokenService.updateRefreshToken(authenticateRes.refresh_token)
    tokenService.updateUserId(`${authenticateRes.user_id}`)
    toastHelpers.handleToast(
      dispatch,
      messages.auth.success,
      SeverityEnum.SUCCESS
    )
    dispatch(loginSuccess())
    history.push(PATH.DASHBOARD)
  }
  const handleError = () => {
    dispatch(unLoading())
    toastHelpers.handleToast(
      dispatch,
      messages.auth.errorHangout,
      SeverityEnum.ERROR
    )
  }
  return (
    <AppLoginContainer>
      <AppLoginHeader>
        <img src={googleChatLogo} alt="" width="32" height="32" />
        <Typography sx={{ ml: 2 }} variant="subtitle2">
          Google Chat
        </Typography>
      </AppLoginHeader>
      <GoogleLogin
        clientId={clientId!}
        render={renderProps => (
          <LoginButton onClick={renderProps.onClick}>
            Login with Google Chat
          </LoginButton>
        )}
        onSuccess={onSuccess}
        cookiePolicy={"single_host_origin"}
      />
      <GoogleLogin
        clientId={clientId!}
        render={renderProps => (
          <InstallButton href="https://www.standupalice.com/google-chat-bot"
          target={"_blank"}>Install</InstallButton>
        )}
        onSuccess={onSuccessInstall}
        cookiePolicy={"single_host_origin"}
      />
      <Typography sx={{ fontSize: 14, mt: 2 }} variant="body2"></Typography>
      <LearnMoreButton
        href={
          "https://standupalice.freshdesk.com/support/solutions/folders/35000211339"
        }
        target={"_blank"}
      >
        Learn more
      </LearnMoreButton>
    </AppLoginContainer>
  )
}

export default GoogleLoginItem
